import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Table, Button, Modal, Dropdown, Input, Form } from 'antd';
import _ from 'lodash';
import cn from 'classnames';
import { formItemLayout } from 'constants/layout';
import { browserHistory } from 'react-router';

import { connect } from 'react-redux';
// import { getCategories } from 'redux/modules/category';
// import { getClassListRecommend, getClassListUpcoming } from 'redux/modules/classroom';
// import { getContents, getContentDistricts, deleteContent,  saveContentDistricts, saveContentProvince } from 'redux/modules/content';
import { getContentDistricts, getContentProvinces, saveContentDistricts, saveContentProvince } from 'data/content';

import Utils from 'utils/utils';

import classes from '../styles/Province.module.scss';

// import classes from './Province.scss';

const FormItem = Form.Item;
const { TextArea } = Input;
const Confirm = Modal.confirm;

class Province extends Component {
  constructor() {
    super();
    this.onClickRow = this.onClickRow.bind(this);

    this.handleCancel = this.handleCancel.bind(this);
    this.changeFocusProvince = this.changeFocusProvince.bind(this);
    this.onAddNewPageContent = this.onAddNewPageContent.bind(this);
    // this.onAddNewPage = this.onAddNewPage.bind(this);
    this.state = {
      collapseMobile: [],
      showModal: false,
      selectedProvince: 'bangkok',
    };
  }

  componentDidMount = async () => {
    const provinces = await getContentProvinces();
    const districts = await getContentDistricts('bangkok');
    this.setState({
      provinces: provinces,
      districts: districts,
    });
    // promises.push(dispatch(getContentDistricts('bangkok')));

    // this.setState({ categories });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  onAddNewPageContent() {
    console.log(this.state.selectedProvince);
    this.setState({
      showModal: true,
      selectedRow: {
        pageName: this.state.selectedProvince,
      },
      isAddNew: true,
    });
  }

  onAddNewProvince = () => {
    this.setState({
      showEditProvinceModal: true,
    });
  };

  onClickRow(record, index) {
    console.log(record, index);
    this.setState({
      showModal: true,
      selectedRow: record,
      isAddNew: false,
    });
  }

  changeFocusProvince = async (value) => {
    const province = value;
    const districts = await getContentDistricts(value);
    // .then((response) => {
    //   console.log(response);
    // });
    this.setState({
      selectedProvince: province,
      districts,
    });
  };

  saveDistricts = (e) => {
    e.preventDefault();
    const props = this.props;
    const _this = this;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
        console.log(values.value, Utils.isJsonString(values.value));
        if (Utils.isJsonString(values.districts)) {
          values.districts = JSON.parse(values.districts);
        } else {
          alert('invalid districts');
          return;
        }

        saveContentDistricts(values.id, values).then(async () => {
          const districts = await getContentDistricts(_this.state.selectedProvince);
          this.setState({
            showModal: false,
            districts,
          });
        });
      }
    });
  };

  handleSubmitProvince = (e) => {
    e.preventDefault();
    const props = this.props;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        saveContentProvince({
          ...values,
        }).then(async () => {
          const provinces = await getContentProvinces();
          this.setState({
            showEditProvinceModal: false,
            provinces,
          });
          // this.changeFocusProvince(values.value);
        });
      }
    });
  };

  handleCancel() {
    this.setState({
      showModal: false,
      selectedRow: null,
      isAddNew: false,
      confirmDirty: false,
      getFieldDecorator: false,
      showEditProvinceModal: false,
    });
  }

  columns = [
    {
      title: 'Name',
      dataIndex: 'key',
      // sorter: (a, b) => {
      //   return a.key.localeCompare(b.key);
      // },
      sortOrder: 'ascend',
    },
    {
      title: 'Value',
      dataIndex: 'value',
      render: (text) => {
        if (!text) {
          return <span></span>;
        }
        if (_.isObject(text) || _.isArray(text)) {
          const newText = JSON.stringify(text);

          return <span>{newText.substring(0, newText.length > 200 ? 200 : newText.length)}</span>;
        }
        const newText = text.toString();
        return <span>{newText.length > 200 ? `${newText.substring(0, 200)}...` : newText}</span>;
      },
    },
  ];

  renderPageTopMenu() {
    const menus =
      this.state.provinces &&
      this.state.provinces.map((province) => (
        <Menu.Item key={province.value} className={cn(classes.dashRight, { [classes.activePageMenu]: province.value === this.state.selectedProvince })}>
          <div>{province.label} </div>
        </Menu.Item>
      ));
    const selectedProvinceObj = _.find(this.state.provinces, { value: this.state.selectedProvince });
    console.log(selectedProvinceObj);
    if (!selectedProvinceObj) {
      return <div></div>;
    }

    return (
      <div className={classes.pageDropdown}>
        <b>Selected Province: </b>
        <Dropdown overlay={<Menu onClick={(selectedMenu) => this.changeFocusProvince(selectedMenu.key)}>{menus}</Menu>} selectedKeys={[this.state.selectedProvince]} trigger={['click']}>
          <Button style={{ marginLeft: 8 }}>
            {selectedProvinceObj.label} <Icon type="down" />
          </Button>
        </Dropdown>
      </div>
    );
  }

  renderAddNewProvinceModal() {
    const { getFieldDecorator } = this.props.form;
    if (!this.state.showEditProvinceModal) {
      return <div />;
    }
    return (
      <Modal
        title={'New page'}
        visible={this.state.showEditProvinceModal}
        onCancel={this.handleCancel}
        footer={[
          <Button key="back" size="large" onClick={this.handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleSubmitProvince}>
            Save
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleSubmitProvince}>
          <FormItem {...formItemLayout} label="Label" hasFeedback>
            {getFieldDecorator('label', {
              rules: [
                {
                  required: true,
                  message: 'Please input Label',
                },
              ],
            })(<Input placeholder="bangkok" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Value" hasFeedback>
            {getFieldDecorator('value', {
              rules: [
                {
                  required: true,
                  message: 'Please input Value',
                },
              ],
            })(<Input placeholder="กรุงเทพ" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Index" hasFeedback>
            {getFieldDecorator('index', {
              rules: [
                {
                  required: true,
                  message: 'Please input Index',
                },
              ],
            })(<Input placeholder="98" />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  renderModal() {
    const { getFieldDecorator } = this.props.form;

    if (!this.state.showModal) {
      return <div />;
    }
    const selectedProvinceObj = _.find(this.state.provinces, { value: this.state.selectedProvince });

    const initValue = _.isObject(this.state.selectedRow.value) || _.isArray(this.state.selectedRow.value) ? JSON.stringify(this.state.selectedRow.value) : this.state.selectedRow.value;

    return (
      <Modal
        title={`${selectedProvinceObj.label}`}
        visible={this.state.showModal}
        onCancel={this.handleCancel}
        width={900}
        footer={[
          <Button key="back" size="large" onClick={this.handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.saveDistricts}>
            Save
          </Button>,
        ]}
      >
        <Form onSubmit={this.saveDistricts} className={classes.modal}>
          <FormItem {...formItemLayout} label="Label" hasFeedback>
            {getFieldDecorator('label', {
              rules: [
                {
                  required: true,
                  message: 'Please input Page',
                },
              ],
              initialValue: selectedProvinceObj.label,
            })(<Input placeholder="bangkok" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Value" hasFeedback>
            {getFieldDecorator('value', {
              rules: [
                {
                  required: true,
                  message: 'Please input Page',
                },
              ],
              initialValue: selectedProvinceObj.value,
            })(<Input placeholder="กรุงเทพ" />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Index" hasFeedback>
            {getFieldDecorator('index', {
              rules: [
                {
                  required: true,
                  message: 'Please input Page',
                },
              ],
              initialValue: selectedProvinceObj.index,
            })(<Input placeholder="98" />)}
          </FormItem>
          <FormItem label="Districts" hasFeedback layout="vertical">
            {getFieldDecorator('districts', {
              rules: [
                {
                  required: true,
                  message: 'Please input Page',
                },
              ],
              initialValue: JSON.stringify(this.state.districts),
            })(<TextArea value={JSON.stringify(this.state.districts)} />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('id', {
              initialValue: selectedProvinceObj._id,
            })(<Input type="hidden" />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  renderContentTable() {
    if (!_.isArray(this.state.districts)) {
      return <Table columns={this.columns} dataSource={[]} bordered pagination={{ pageSize: 1000 }} onRowClick={this.onClickRow} />;
    }
    const content = _.map(this.state.districts, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    return <Table columns={this.columns} dataSource={content} bordered pagination={{ pageSize: 1000 }} onRowClick={this.onClickRow} />;
  }

  render() {
    return (
      <div>
        <div className="page-header">{this.props.BreadCrumb}</div>
        <div className="content">
          <div className={cn(classes.addBtnContainer, 'pull-right')}>
            <Button type="primary" onClick={this.onAddNewPageContent}>
              <Icon type="plus" size="large" />
              แก้ไขพื้นที่
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button type="primary" onClick={this.onAddNewProvince}>
              <Icon type="plus" size="large" />
              เพิ่มจังหวัด
            </Button>
          </div>
          {this.renderPageTopMenu()}
          {this.renderContentTable()}
          {this.renderModal()}
          {this.renderAddNewProvinceModal()}
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    // pages: state.content.pages,
    // content: state.content.contentList,
  }),
  {},
)(Form.create()(Province));
